import { useEngineModeSignal } from '../../../rx/signal/useEngineModeSignal'
import createEngineRoot from './createEngineRoot'
import { EngineMode } from './EngineMode/EngineMode.enum'
import { getDefaultStateMapDisk } from '../state/getDefaultStateMapDisk'

// placeholder for declaring intent
const createEngineForMapEditor = function () {
  const engine = createEngineRoot(getDefaultStateMapDisk())
  return Object.assign(engine, {
    mode: EngineMode.MapEditor,
  })
}

export default function () {
  const engine = createEngineForMapEditor()
  const [, setEngineMode] = useEngineModeSignal(engine)
  setEngineMode(EngineMode.MapEditor)
  return engine
}
